<template>
  <b-row>
    <b-col col="12">
      <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
      <b-card>
        <div slot="header">
          Campaign: {{campaign.title}}
        </div>
        <campaign-form :campaign="campaign" type="edit" />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import VueLoading from "vue-loading-overlay/src/js/Component";
import {RepositoryFactory} from "@/services/repositories/RepositoryFactory";
import CampaignForm from "@/components/newsletter/Campaign/CampaignForm";

export default {
  name: "Campaign",
  components: {
    CampaignForm,
    VueLoading,
  },
  data() {
    return {
      campaign: null,
      campaignId:this.$route.params.campaignId,
      isLoading: true,
    }
  },
  mounted() {
    RepositoryFactory
      .get('newsletterCampaign')
      .getCampaign(this.campaignId)
      .then(
        response => {
          this.campaign = response.data.data;
          this.isLoading = false;
        }
      )
    ;
  }
}
</script>
